import CreateAccount from "components/Account/createAccount";
import ForgotPassword from "components/Authentication/forgotPassword";
import Login from "components/Authentication/login";
import LoginOtp from "components/Authentication/loginOtp";
import ResetPassword from "components/Authentication/resetPassword";
import BlogDetail from "components/BlogDetail";
import Blog from "components/Blogs";
import Conditions from "components/Conditions";
import HomePage from "components/HomePage";
import LandingScreen from "components/LandingScreen";
import Layout from "components/Layout";
import OnboardStep from "components/Onboard";
import UploadImage from "components/Onboard/components/UploadImage";
import PersonProfile from "components/PersonProfile";
import Privacy from "components/PrivacyPolicy";
import SuccessStories from "components/SuccessStories";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Explore from "../components/Explore";
import Engage from "components/Engage";
import Verification from "components/Verification";
import Settings from "../components/Settings";
import ActivityLog from "components/ActivityLog";
import MyProfile from "components/MyProfile";
import ManagePhotos from "components/ManagePhotos";
import Plans from "components/Plans";
import PlansList from "components/Plans/components/PlansList";
import SuccessStoryDetail from "components/SuccessStoriesDetail";
import Connect from "components/Connect";
import GuestRoute from "./GuestRoute";
import PrivateRoute from "./PrivateRoute";
import WeddingStore from "components/WeddingStore";
import Chats from "components/Chats";
import Search from "components/Search";
function AppRouter() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <GuestRoute>
          <Layout isLanding>
            <LandingScreen />
          </Layout>
        </GuestRoute>
      ),
    },
    {
      path: "/home",
      element: (
        <PrivateRoute>
          <Layout>
            <HomePage />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/onboard",
      element: <OnboardStep />,
    },
    {
      path: "/onboard/upload",
      element: (
        <PrivateRoute>
          <UploadImage />
        </PrivateRoute>
      ),
    },
    {
      path: "/person-profile/:id",
      element: (
        <PrivateRoute>
          <Layout>
            <PersonProfile />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/blog",
      element: (
        <PrivateRoute>
          <Layout>
            <Blog />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/blog/details/:id",
      element: (
        <PrivateRoute>
          <Layout>
            <BlogDetail />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/success-stories",
      element: (
        <PrivateRoute>
          <Layout>
            <SuccessStories />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/success-stories/details/:id",
      element: (
        <PrivateRoute>
          <Layout>
            <SuccessStoryDetail />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/terms-and-conditions",
      element: <Conditions />,
    },
    {
      path: "/privacy-policy",
      element: <Privacy />,
    },
    {
      path: "/s/:id",
      element: (
        <PrivateRoute>
          <Layout>
            <Search />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/explore",
      element: (
        <PrivateRoute>
          <Layout isFooter={false}>
            <Explore />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/engage",
      element: (
        <PrivateRoute>
          <Layout>
            <Engage />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/verification",
      element: (
        <PrivateRoute>
          <Layout>
            <Verification />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/settings",
      element: (
        <PrivateRoute>
          <Layout>
            <Settings />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/activity-log",
      element: (
        <PrivateRoute>
          <Layout>
            <ActivityLog />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/my-profile",
      element: (
        <PrivateRoute>
          <Layout>
            <MyProfile />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/my-profile/photos",
      element: (
        <PrivateRoute>
          <Layout>
            <ManagePhotos />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/plans",
      element: (
        <PrivateRoute>
          <Layout>
            <Plans />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/plans/list",
      element: (
        <PrivateRoute>
          <Layout>
            <PlansList />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/connect",
      element: (
        <PrivateRoute>
          <Layout>
            <Connect />
          </Layout>
        </PrivateRoute>
      ),
    },
    {
      path: "/wedding-store",
      element: (
        <PrivateRoute>
          <Layout>
            <WeddingStore />
          </Layout>
        </PrivateRoute>
      ),
    },
    ...[
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/login-otp",
        element: (
          <GuestRoute>
            <LoginOtp />
          </GuestRoute>
        ),
      },
      {
        path: "/forgot",
        element: <ForgotPassword />,
      },
      {
        path: "/reset",
        element: (
          <GuestRoute>
            <ResetPassword />
          </GuestRoute>
        ),
      },
      {
        path: "/create",
        element: <CreateAccount />,
      },
      {
        path: "/connect/chats",
        element: (
          <PrivateRoute>
            <Layout>
              <Chats />
            </Layout>
          </PrivateRoute>
        ),
      },
    ],
  ]);

  return <RouterProvider router={router} />;
}

export default AppRouter;
